import styled from 'styled-components';


export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }

  .go-back {
    margin: 0 !important;
    position: absolute;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 30px 0 40px;
  grid-column-gap: 4%;

  &.attempt-selector-row {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      margin: 0 35px 0 0;
      font-size: 18px;
      font-weight: 700;
      color: white;
    }

    select {
      max-width: 270px;
      margin: 0;
    }
  }

  h1 {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: #3ee9f7;
    text-align: center;
    font-size: 26px;
    margin-top: 15px;
  }

  @media all and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    p.go-back {
      margin-bottom: 1em;
    }
    h1 {
      font-size: 22px;
    }
  }
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 40px;

  @media all and (max-width: 1200px) {
    margin: 1em 0;
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Students/DataCentre/LessonDetails/LessonDetails.styles.ts